(() => {
  'use strict';
  const card = document.querySelector('[data-pack-promo]');
  const shop = document.getElementById('shop');
  const pack = document.getElementById('pack');
  if (!card || !shop || !pack || window.Shopify?.designMode) return;
  const key = 'mymask.pack-promo.v1';
  try { if (sessionStorage.getItem(key)) return; } catch (_) {}
  let dismissed = false;
  let ready = false;
  const visible = element => {
    const bounds = element.getBoundingClientRect();
    return bounds.bottom > 0 && bounds.top < innerHeight;
  };
  const blocked = () => document.hidden || [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner')].some(element => element.getClientRects().length);
  const remember = () => { try { sessionStorage.setItem(key, 'seen'); } catch (_) {} };
  const dismiss = () => { dismissed = true; card.hidden = true; remember(); };
  const update = () => {
    if (dismissed) return;
    if (visible(pack)) { dismiss(); return; }
    const show = ready && visible(shop) && !blocked() && !document.querySelector('.mobile-nav[open]');
    card.hidden = !show;
    if (show) remember();
  };
  card.querySelector('[data-dismiss-promo]').addEventListener('click', () => {
    dismiss();
    const target = shop.querySelector('a');
    if (target) target.focus({ preventScroll: true });
  });
  card.querySelector('[data-promo-link]').addEventListener('click', event => {
    event.preventDefault();
    dismiss();
    const destination = new URL(location.href);
    destination.hash = 'pack';
    if (location.hash !== '#pack') history.pushState(history.state, '', destination);
    pack.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    pack.querySelector('input')?.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !card.hidden) {
      const hadFocus = card.contains(document.activeElement);
      dismiss();
      if (hadFocus) shop.querySelector('a')?.focus({ preventScroll: true });
    }
  });
  addEventListener('scroll', update, { passive: true });
  document.addEventListener('visibilitychange', update);
  document.querySelectorAll('dialog').forEach(dialog => new MutationObserver(update).observe(dialog, { attributes: true, attributeFilter: ['open'] }));
  document.querySelector('.mobile-nav')?.addEventListener('toggle', update);
  document.addEventListener('visitorConsentCollected', update);
  setTimeout(() => { ready = true; update(); }, 20000);
})();
